/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
// SB-260 Change image asset for Starbreeze: START
import blankPage from "assets/starbreeze/images/Legal-Doc.svg";
// SB-260 Change image asset for Starbreeze: END
// SB-260 remove background asset for Starbreeze
import { Button } from "components/base/_common/index";
import styles from "./ErrorPage.module.scss";

export default class extends React.Component {
  render() {
    return (
      // SB-260 remove background asset for Starbreeze: START
      <div className={styles.errorPage}>
        <div className={styles.errorPageContent}>
          <div className={styles.errorPageText}>
            <div>
              <img src={blankPage} alt="blank page" />
            </div>

            <h3>
              <Trans i18nKey="ErrorPage401.heading">Error 401 - Unauthorized</Trans>
            </h3>
            <div className={styles.textContent}>
              <Trans i18nKey="ErrorPage401.textContent">
                <p>The page you want to access is publicly unavailable.</p>
              </Trans>

              <div>
                <Link to="/">
                  <Button>
                    <Trans i18nKey="ErrorPage401.buttonAction">Back To Home</Trans>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      // SB-260 remove background asset for Starbreeze: END
    );
  }
}
